import config from '@/config';
import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { insertNewMainTask } from '@/shared/utils/infiniteDataHelper';
import { TaskQueryKey } from './queryKey';
export var useCreatePlannedTask = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (values) {
        return api.base
            .post("".concat(config.appUrls.tasks, "/api/plannedTasks"), values)
            .then(function (res) { return res.data; });
    }, {
        onSuccess: function (data) {
            queryClient.setQueryData([TaskQueryKey.PlannedTasks], function (oldData) {
                return insertNewMainTask(oldData, data);
            });
        },
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading, error = _a.error;
    return {
        createPlannedTask: mutateAsync,
        isLoading: isLoading,
        error: error,
    };
};
